"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Join = void 0;
var _react = _interopRequireDefault(require("react"));
var _flattenChildren = require("../../helpers/flattenChildren");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * `Join` is a higher order component that renders a separator component
 * between each of `Join`'s direct children.
 *
 * @example
 *
 *  <Join separator={<SomeComponent/>}>
 *    <child1/>
 *    <child2/>
 *    <child3/>
 *  </Join>
 *
 * which renders
 *
 * <child1/>
 * <SomeComponent/>
 * <child2/>
 * <SomeComponent/>
 * <child3/>
 */
var Join = function Join(_ref) {
  var separator = _ref.separator,
    children = _ref.children;
  var elements = (0, _flattenChildren.flattenChildren)(children);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, elements.reduce(function (acc, element, currentIndex) {
    acc.push(
    /*#__PURE__*/
    // @ts-expect-error  MIGRATE_STRICT_MODE
    _react.default.cloneElement(element, {
      key: "join-".concat(currentIndex)
    }));
    if (currentIndex !== elements.length - 1) {
      acc.push(
      // @ts-expect-error  MIGRATE_STRICT_MODE
      separator && /*#__PURE__*/_react.default.cloneElement(separator, {
        key: "join-sep-".concat(currentIndex)
      }));
    }
    return acc;
  }, []));
};
exports.Join = Join;
//# sourceMappingURL=Join.js.map